<cdk-accordion class="accordion menu-dashboard">
  <ng-container *ngIf="pages$ | async as pages">
    <ng-container *ngFor="let page of pages; let pageIndex = index">
      <cdk-accordion-item
        *ngFor="let itemGroup of page.content.items; let itemGroupIndex = index"
        [expanded]="pageIndex === 0 && itemGroupIndex === 0"
        #accordionItem="cdkAccordionItem"
        class="item"
        role="button"
        tabindex="0"
        [attr.id]="'header-' + pageIndex + '-' + itemGroupIndex"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'body-' + itemGroupIndex"
      >
        <div class="header pb-0">
          <a
            (click)="accordionItem.open()"
            [routerLink]="['research', page.id, itemGroup.id]"
            routerLinkActive="active"
          >
            {{ getText(itemGroup.name) }}</a
          >
          <span class="item-description pointer" (click)="accordionItem.toggle()">
            <div class="arrow" [ngClass]="{ closed: accordionItem.expanded }"></div>
          </span>
        </div>
        <div
          class="item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'body-' + pageIndex + '-' + itemGroupIndex"
          [attr.aria-labelledby]="'header-' + pageIndex + '-' + itemGroupIndex"
        >
          <cdk-accordion [multi]="true" class="nested-accordion">
            <ng-container *ngFor="let item of itemGroup.items; let itemPageIndex = index">
              <cdk-accordion-item
                *ngIf="item.kind === 'itempage'"
                [expanded]="item.id === (surveyResearchItemPageId$ | async) && itemGroupIndex === 0"
                #accordionItem="cdkAccordionItem"
                class="item"
                role="button"
                tabindex="0"
                [attr.id]="'header-' + itemPageIndex"
                [attr.aria-expanded]="accordionItem.expanded"
                [attr.aria-controls]="'body-' + itemPageIndex"
              >
                <div class="header pl-2">
                  <a
                    (click)="accordionItem.open()"
                    [routerLink]="['research', page.id, itemGroup.id, item.id]"
                    routerLinkActive="active"
                    class="pointer"
                  >
                    {{ item.name | getTranslation: logEmptyTitle }}
                  </a>
                  <span (click)="accordionItem.toggle()" class="item-description pointer">
                    <div class="arrow" [ngClass]="{ closed: accordionItem.expanded }"></div>
                  </span>
                </div>
                <div
                  class="item-body"
                  role="region"
                  [style.display]="accordionItem.expanded ? '' : 'none'"
                  [attr.id]="'body-' + itemPageIndex"
                  [attr.aria-labelledby]="'header-' + itemPageIndex"
                >
                  <ul>
                    <ng-container *ngFor="let itemPageEl of item.items | filterCallback: isSection; let i = index">
                      <li>
                        <a
                          [routerLink]="['research', page.id, itemGroup.id, item.id]"
                          [fragment]="'section-' + (i + 1)"
                          >{{ getTitleOfSection(itemPageEl) }}</a
                        >
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </cdk-accordion-item>
            </ng-container>
          </cdk-accordion>
        </div>
      </cdk-accordion-item>
    </ng-container>
  </ng-container>
</cdk-accordion>
<lib-lang-droplist class="lang-switcher"></lib-lang-droplist>
